// extracted by mini-css-extract-plugin
export var headerCell = "_60-1";
export var loadingSpinnerContainer = "_60-4";
export var loadingStateCell = "_60-5";
export var rowWrapper = "_60-3";
export var standaloneTable = "_60-6";
export var table = "_60-0";
export var white = "_60-2";